import { usePosts } from "@/hooks/useBlog";
import { JournalCard } from "@/pages/blog/JournalParts";

interface RelatedPostsProps {
  currentSlug: string;
  currentCategory: string;
  limit?: number;
}

export const RelatedPosts = ({ currentSlug, currentCategory, limit = 3 }: RelatedPostsProps) => {
  const { data: allPosts = [] } = usePosts();
  const candidates = [...allPosts].filter(post => post.slug !== currentSlug).sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());
  const related = [...candidates.filter(post => post.category === currentCategory), ...candidates.filter(post => post.category !== currentCategory)].slice(0, limit);
  if (!related.length) return null;

  return <section className="pf-journal-related" aria-labelledby="related-title"><div className="pf-journal-section-heading"><h2 id="related-title">À lire aussi</h2><span>Continuer la lecture</span></div><div className="pf-journal-grid">{related.map((post, index) => <JournalCard key={post.slug} post={post} index={index} />)}</div></section>;
};
